var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 45 0 C 20.187 0 0 20.187 0 45 c 0 24.813 20.187 45 45 45 c 24.813 0 45 -20.187 45 -45 C 90 20.187 69.813 0 45 0 z M 4.051 47 H 20.07 c 0.142 6.123 0.934 11.89 2.255 17.096 H 8.735 C 6.011 58.944 4.348 53.149 4.051 47 z M 47 21.905 V 4.2 c 6.216 1.214 11.734 8.007 15.192 17.705 H 47 z M 63.455 25.905 C 64.89 31.084 65.772 36.89 65.931 43 H 47 V 25.905 H 63.455 z M 43 4.2 v 17.705 H 27.809 C 31.266 12.207 36.784 5.414 43 4.2 z M 43 25.905 V 43 H 24.069 c 0.159 -6.11 1.041 -11.916 2.476 -17.095 H 43 z M 20.07 43 H 4.051 c 0.297 -6.149 1.96 -11.944 4.684 -17.095 h 13.59 C 21.003 31.11 20.211 36.877 20.07 43 z M 24.069 47 H 43 v 17.096 H 26.545 C 25.111 58.917 24.228 53.111 24.069 47 z M 43 68.096 V 85.8 c -6.216 -1.214 -11.733 -8.007 -15.191 -17.705 H 43 z M 47 85.8 V 68.096 h 15.192 C 58.734 77.793 53.216 84.586 47 85.8 z M 47 64.096 V 47 h 18.931 c -0.159 6.111 -1.041 11.917 -2.476 17.096 H 47 z M 69.931 47 h 16.018 c -0.297 6.149 -1.96 11.944 -4.684 17.096 H 67.676 C 68.997 58.89 69.789 53.123 69.931 47 z M 69.931 43 c -0.142 -6.123 -0.934 -11.89 -2.255 -17.095 h 13.589 c 2.724 5.152 4.387 10.946 4.684 17.095 H 69.931 z M 78.855 21.905 H 66.523 c -2.153 -6.613 -5.219 -12.087 -8.909 -15.911 C 66.331 8.82 73.779 14.487 78.855 21.905 z M 32.386 5.994 c -3.689 3.824 -6.755 9.298 -8.909 15.911 H 11.145 C 16.221 14.487 23.669 8.82 32.386 5.994 z M 11.146 68.096 h 12.332 c 2.153 6.612 5.219 12.086 8.909 15.911 C 23.669 81.18 16.222 75.513 11.146 68.096 z M 57.614 84.006 c 3.689 -3.824 6.756 -9.298 8.909 -15.91 h 12.332 C 73.778 75.513 66.331 81.18 57.614 84.006 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/Website.670773fdef36e9e2e5610ba262dee422.svg";
export { ForwardRef as ReactComponent };